import genericTabConst from './genericTab.const';

export default Object.freeze({
  [genericTabConst.OTHER]: '',
  [genericTabConst.SCOPE]: 'scope',
  [genericTabConst.PROPERTY]: 'property',
  [genericTabConst.PUBLIC]: 'public',
  [genericTabConst.MARKET_RENT]: 'revenueUnits',
  [genericTabConst.LEASE_COMPS]: 'leaseComparable',
  [genericTabConst.RENT_SURVEY_COMPS]: 'rentSurveyComparable',
  [genericTabConst.SALES_COMPS]: 'salesComparable',
  [genericTabConst.SALES_INFO]: 'salesInfo',
  [genericTabConst.LAND_COMPS]: 'landComparable',
  [genericTabConst.IE_COMPS]: 'ieComparable',
  [genericTabConst.CALCULATIONS]: 'calculations',
  [genericTabConst.DOCUMENTS]: 'documentProperty',
  [genericTabConst.REPORT]: 'report',
  [genericTabConst.READER]: 'https://analytics4.jll.com/@/site/VALS/views/demographics_v05_v2020_3_prod/Dashboard',
  [genericTabConst.LEASE_RESEARCH]: 'leaseComparable',
  [genericTabConst.SALES_RESEARCH]: 'salesComparable',
  [genericTabConst.LAND_RESEARCH]: 'landComparable',
});
